export const USER_IDENTITY = "user_identity"
export const USER_CERTIFICATION_LEVEL = "user_certification_level"
export const BOAT_INSURANCE = "boat_insurance"
